import { formatRelativeDate } from '../../../utils/FormatDate';

const BatchExpirationRenderer = ({ data }) => {
  const sub = [data.dosage, data.presentation].filter(Boolean).join(' · ');
  return (
    <>
      <p className="bell-card__name">{data.productName || '—'}</p>
      {sub && <p className="bell-card__sub">{sub}</p>}
      <p className="bell-card__detail">
        Expire <strong>{formatRelativeDate(data.expirationDate)}</strong>
      </p>
    </>
  );
};

export default BatchExpirationRenderer;
